import { EXPRESS_API } from 'configs/api/expressApi';
import { IQuickShareMarkAsSentParams } from './quickshare/useQuickShareMarkAsSentMutation';

export type GetQuickshareParams = {
  templateId?: number | string;
  linksetId?: number | string;
  overlayId?: number | string;
  iconId?: number | string;
  vin?: number | string;
  format?: string;
  useAutomotive?: boolean;
  allowVideoReply?: boolean;
  allowReactions?: boolean;
  notifyUser?: boolean;
};

export const getQuickshareDetails = async (
  videoId: string | number | undefined,
  params?: IQuickShareMarkAsSentParams | GetQuickshareParams
) => {
  const response = await EXPRESS_API.get(`/share/quickshare/${videoId}`, {
    params,
  });

  return response.data;
};
